import React from 'react';

const viStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 12"
    style={{
      width: '1em',
      height: '1em',
      overflow: 'visible',
    }}
  >
    <g fill="none" fillRule="evenodd">
      {/* eslint-disable-next-line max-len */}
      <path fill="currentColor" d="M6 8.886l3.09 1.864-.817-3.514L11 4.872l-3.596-.308L6 1.25 4.596 4.564 1 4.872l2.728 2.364-.818 3.514z" />
    </g>
  </svg>
);

export default viStar;
